import * as React from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Profile, hasOneOfProfiles } from "../../domain/sfp/user-domain"
import { User } from "../../model"
import { IconProp } from "@fortawesome/fontawesome-svg-core";

class ToolbarComponent extends React.Component<ToolbarComponentProps> {
	public static defaultProps: Partial<ToolbarComponentProps> = {
		items: [],
		loading: false
	}

	render() {
		const items = this.props.items
		const loading = this.props.loading
		const user = this.props.user

		if (!items.length || !user) return <div />

		return <div className="toolbar">
			{items.map((item, i) =>
				(!(item.allowedProfiles && item.allowedProfiles.length)
				|| (user && hasOneOfProfiles(user, item.allowedProfiles)))
				? isButtonToolbarItem(item)
					? this.renderButtonItem(item, i, loading)
					: (isLinkToolbarItem(item) ? this.renderLinkItem(item, i) : null)
				: null)}
		</div>
	}

	private renderButtonItem(
		item: ButtonToolbarItem,
		key: number,
		loading: boolean
	): JSX.Element {
		return (
			<button className="toolbar-button"
			disabled={loading}
			key={key}
			onClick={item.onClick}
			title={item.title}>
				{this.renderItemContent(item)}
			</button>
		)
	}

	private renderLinkItem(
		item: LinkToolbarItem,
		key: number
	): JSX.Element {
		return (
			<Link className="toolbar-button"
			key={key}
			title={item.title}
			to={item.to}>
				{this.renderItemContent(item)}
			</Link>
		)
	}

	private renderItemContent(item: ToolbarItem): React.ReactNode {
		if (item.icon && item.text)
			return [
				<FontAwesomeIcon icon={item.icon} key={0} />,
				<span key={1}>{item.text}</span>
			]

		if (item.text) return <span>{item.text}</span>

		return <FontAwesomeIcon icon="exclamation-triangle" />
	}
}

function isButtonToolbarItem(item: BaseToolbarItem): item is ButtonToolbarItem {
	return undefined !== (item as ButtonToolbarItem).onClick
}

function isLinkToolbarItem(item: BaseToolbarItem): item is LinkToolbarItem {
	return undefined !== (item as LinkToolbarItem).to
}

interface BaseToolbarItem {
	allowedProfiles?: Profile[]
	icon?: IconProp
	text?: string
	title?: string
}

export default ToolbarComponent

export interface ToolbarComponentProps {
	items?: ToolbarItem[]
	loading?: boolean
	user: User
}

export interface ButtonToolbarItem extends BaseToolbarItem {
	onClick(e: React.SyntheticEvent<any>): void
}

export interface LinkToolbarItem extends BaseToolbarItem {
	to: string
}

export type ToolbarItem = ButtonToolbarItem | LinkToolbarItem



// WEBPACK FOOTER //
// ./src/component/toolbar/toolbar-component.tsx